<template>
  <div>
    <a-modal
      :width="this.settings['isMobileView'] ? 420 : this.settings['isTabletView'] ? 600 : 840"
      v-model="visible"
      title="Add Application Form"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <template v-if="applicationData">
          <a-button key="submit" type="primary" :disabled="applicationData.applicants_count !== 0" :loading="spinning" @click="handleEdit">
            Update Application Form
          </a-button>
        </template>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-0" :form="form" @submit="handleEdit">
          <div v-if="applicationData && applicationData.applicants_count !== 0" class="mb-3">
            <a-alert message="This form as applicants already signed up! you cannot edit this form." type="info" show-icon>
            </a-alert>
          </div>
          <p class="text-uppercase font-weight-bold text-muted">Application form details - {{this.applicationFormId}}</p>
          <div class="row mb-2">
            <div class="col-md-3 mb-2">
              <a-form-item label="For Session">
                <a-spin :spinning="sessionSpinning">
                  <a-select
                    v-decorator="[
                      'session_id',
                      {rules: [{ required: true, message: 'Please select a session!' }], initialValue: currentSession ? currentSession.id : ''}
                    ]"
                    :disabled="true"
                    placeholder="Select Class"
                    @change="handleSessionChange"
                  >
                      <a-select-option v-for="schoolSession in schoolSessions" :value="schoolSession.id" :key="schoolSession.id">
                        {{schoolSession.name}}
                        <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
                      </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <div class="col-md-3 mb-2">
              <a-form-item label="For Class">
                <a-spin :spinning="classSpinning">
                  <a-select
                    v-decorator="[
                      'class_id',
                      {rules: [{ required: true, message: 'Please select a class!' }]}
                    ]"
                    placeholder="Select Class"
                  >
                      <a-select-option v-for="schoolClass in schoolClasses" :value="schoolClass.id" :key="schoolClass.id">
                        {{schoolClass.name}}
                      </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <div class="col-md-3 mb-2">
              <a-form-item label="Start Date">
              <a-date-picker
                v-decorator="[
                'start_date',
                {rules: [{ required: true, message: 'Please input a start date' }], initialValue: moment()},
                ]"
                :format=dateFormat />
              </a-form-item>
            </div>
            <div class="col-md-3 mb-2" >
              <a-form-item
                label="End Date"
              >
              <a-date-picker
                v-decorator="[
                'end_date',
                {rules: [{ required: true, message: 'Please input an end date' }], },
                ]"
                :format=dateFormat />
              </a-form-item>
            </div>
            <div class="col-md-3 mb-2">
              <a-form-item class="mb-0" label="Application Fee">
                <div style="width:180px;">
                  <a-input-number
                    placeholder="Fee Amount"
                    v-decorator="[`application_fee`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                    :initialValue="0"
                    :min="0"
                    :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                    style="width:100%;"
                  />
                </div>
              </a-form-item>
            </div>
            <div class="col-md-3 mb-2">
              <a-form-item label="Payment Mode">
                <a-select
                  v-decorator="[
                    'payment_mode',
                    {rules: [{ required: form.getFieldValue('application_fee'), message: 'Please select a payment mode!' }], initialValue: undefined}
                  ]"
                  placeholder="Select Class"
                >
                    <a-select-option :value="undefined">
                      Select Option
                    </a-select-option>
                    <a-select-option v-for="onlineApplicationPaymentMode in onlineApplicationPaymentModes" :value="onlineApplicationPaymentMode.value" :key="onlineApplicationPaymentMode.value">
                      {{onlineApplicationPaymentMode.name}}
                    </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-3 mb-2">
              <a-form-item label="Enable online admission">
                <a-select
                  v-decorator="[
                    'online_admission',
                    {rules: [{ required: true, message: 'Please select an option!' }], initialValue: 0}
                  ]"
                  placeholder="Select Class"
                >
                    <a-select-option :value="0">
                      No
                    </a-select-option>
                    <a-select-option :value="1">
                      Yes
                    </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-3 mb-2" >
              <a-form-item
                label="Admission Last Date"
              >
              <a-date-picker
                v-decorator="[
                'admission_last_date',
                {rules: [{ required: form.getFieldValue('online_admission') === 1, message: 'Please input a date' }], },
                ]"
                :format=dateFormat />
              </a-form-item>
            </div>
             <div class="col-md-4 mb-2" v-if="form.getFieldValue('class_id') && form.getFieldValue('online_admission') === 1">
              <a-form-item label="Admission Fee">
                <a-spin :spinning="feeSpinning">
                  <a-select
                    v-decorator="[
                      'admission_fee_id',
                      {rules: [{ required: form.getFieldValue('online_admission') === 1, message: 'Please select a fee!' }], initialValue: undefined}
                    ]"
                    placeholder="Select Admission Fee"
                  >
                      <a-select-option :value="undefined">
                        Select Option
                      </a-select-option>
                      <a-select-option v-for="classFee in classFees" :value="classFee.id" :key="classFee.id">
                        {{classFee.fee.name}} ({{classFee.fee_amount}})
                      </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
          </div>
          <p class="text-uppercase font-weight-bold text-muted">Subject groupings</p>
          <div class="row mb-4">
            <div class="col-12" v-for="(key, index) in subjectGroupings" :key="key">
              <div class="d-flex">
                <div class="mr-2 pt-2">
                  <span class="font-weight-bold">{{index + 1}}.</span>
                </div>
                <div class="col">
                <a-form-item>
                  <a-spin :spinning="subGroupSpinning">
                    <a-select
                      style="width: 100%"
                      v-decorator="[
                        `sub_grp_master_id[${key}]`,
                        {
                          rules: [
                            {
                              required: true,
                              message: 'Please select a Subject Group!',
                            },
                          ],
                        },
                      ]"
                      placeholder="Select a group"
                    >
                      <a-select-option
                        v-for="group in subjectGroups"
                        :value="group.id"
                        :key="group.id"
                      >
                        {{ group.name }}
                      </a-select-option>
                    </a-select>
                  </a-spin>
                </a-form-item>
              </div>
                <div class="flex-grow-1">
                  <a-form-item>
                    <a-select
                      v-decorator="[
                        `subject_group[${key}]`,
                        {rules: [{ required: true, message: 'Please select subjects' }], initialValue:[]}
                      ]"
                      placeholer="Select subjects"
                      mode="multiple"
                      style="width: 100%"
                    >
                      <a-select-option v-for="subject in subjects" :key="subject.id">
                        {{ subject.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
                <div class="ml-2 pt-1">
                  <a-button class="btn btn-sm btn-danger" :disabled="applicationData.applicants_count !== 0"  @click.prevent="handleRemoveSubjectGrouping(key)">
                    <i class="btn-addon-icon fe fe-trash-2" />
                  </a-button>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="border-top border-bottom">
                <button class="btn btn-link pl-0" @click.prevent="handleAddSubjectGrouping">
                  + Add subject grouping
                </button>
              </div>
            </div>
          </div>
          <div class="row mb">
            <div class="col-12 mb-2">
              <a-form-item
                label="Selection criteria"
              >
              <a-textarea
                v-decorator="[
                  'selection_criteria',
                  {rules: [{ required: false, message: 'Please add a selection criteria!' }],}
                ]"
                placeholder="Enter selection criteria briefly.."
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
              </a-form-item>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { find } from 'lodash'
import { mapState } from 'vuex'

import { onlineApplicationPaymentModes } from '@/services/globaldata.js'

export default {
  name: 'EditApplicationForm',
  props: ['classId', 'sessionId'],
  data: function() {
    return {
      form: this.$form.createForm(this),
      applicationFormId: null,
      spinning: false,
      onlineApplicationPaymentModes,
      loading: false,
      visible: false,
      classSpinning: false,
      sessionSpinning: false,
      feeSpinning: false,
      classFees: [],
      schoolClasses: [],
      schoolSessions: [],
      subjects: [],
      applicationData: null,
      selectedSession: undefined,
      dateFormat: 'DD-MM-YYYY',
      subjectGroupings: [],
      subjectMasterGroupings: [],
      groupingCounter: 0,
      subjectGroups: [],
    }
  },
  mounted: function () {
    this.$eventBus.$on('openApplicationFormEditModal', this.showModal)
    this.getSessions()
  },
  watch: {
    subjectGroups: function (val) {
      return val
    },
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
    ...mapState(['user', 'settings']),
  },
  methods: {
    moment,
    getSubjectGroups: function() {
      this.subGroupSpinning = true
      this.$http.get('/api/subject-group')
        .then(({ data }) => {
          this.subjectGroups = data.data
          this.subGroupSpinning = false
        })
    },
    showModal: function(applicationFormId) {
      this.visible = true
      this.spinning = true

      this.subjectGroupings = []
      this.groupingCounter = 0

      this.getClasses()
      this.applicationFormId = applicationFormId
    },
    getApplicationForm() {
      this.spinning = true
      this.$http.get(`/api/online-application/${this.applicationFormId}`)
        .then(({ data }) => {
          this.applicationData = data.data
          this.getClassFees(data.data.class_id, data.data)
          this.makeApplicationFormData(data.data)
          this.spinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSessions: function() {
      this.sessionSpinning = true
      this.$http.get('/api/session')
        .then(({ data }) => {
          this.schoolSessions = data.data
          this.selectedSession = find(data.data, ['is_current', 1]).id
          this.getClasses()
          this.sessionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClasses: function() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.getSubjectGroups()
          this.classSpinning = false
          this.getSubjects()
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSubjects: function() {
      this.$http.get('/api/subject')
        .then(({ data }) => {
          this.subjects = data.data
          if (this.applicationFormId) {
            this.getApplicationForm(this.applicationFormId)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedClass = undefined

      this.getClasses()
    },
    handleClassChange (value) {
      this.classFees = []
      if (value) {
        this.getClassFees(value)
      }
    },
    getClassFees(classId, formData = null) {
      this.feeSpinning = true
      this.$http.get('/api/class_fees', {
        params: {
          session_id: this.selectedSession,
          class_id: classId,
        },
      })
        .then(({ data }) => {
          this.feeSpinning = false
          this.classFees = data.data

          this.$nextTick(() => {
            this.form.setFieldsValue({
              admission_fee_id: formData.admission_fee_id,
            })
          })
        })
        .catch(error => {
          this.feeSpinning = false
          console.log(error)
        })
    },
    handleAddSubjectGrouping () {
      this.groupingCounter++
      if (this.subjectGroupings.length < 10) {
        this.subjectGroupings.push(this.groupingCounter)
      }
    },
    handleRemoveSubjectGrouping(key) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Click Ok to remove this subject grouping.`,
        onOk: () => {
          this.subjectGroupings = this.subjectGroupings.filter(item => item !== key)
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },

    handleEdit: function (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              let onlineApplicationFormData = this.makeOnlineApplicationFormData(values)
              const subGroupObjectlist = []
              onlineApplicationFormData.sub_grp_master_id.forEach((value, index1) => {
                subGroupObjectlist.push({
                  sub_grp_master_id: value,
                  subjectIds: onlineApplicationFormData.subject_group[index1 - 1],
                })
              })
              onlineApplicationFormData.subject_group = subGroupObjectlist
              this.$http
                .patch(`/api/online-application/${this.applicationFormId}`, onlineApplicationFormData)
                .then(({ data }) => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Application form edit successfully!',
                    description: `The application form has been successfully edited.`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    makeApplicationFormData: function(data) {
      const fieldData = {
        class_id: data.class_id,
        session_id: data.session_id,
        start_date: moment(data.start_date),
        end_date: moment(data.end_date),
        application_fee: data.application_fee,
        payment_mode: data.payment_mode,
        online_admission: data.online_admission,
        admission_last_date: moment(data.admission_last_date),
        selection_criteria: data.selection_criteria,
      }

      if (data.subject_groups.length > 0) {
        this.groupingCounter = data.subject_groups.length
        for (let i = 0; i < data.subject_groups.length; i++) {
          this.subjectGroupings.push(i + 1)
          fieldData[`subject_group[${i + 1}]`] = data.subject_groups[i].subjects.map(element => {
            return element.id
          })
        }
      }
      if (data.subject_groups.length > 0) {
        this.groupingCounter = data.subject_groups.length
        for (let i = 0; i < data.subject_groups.length; i++) {
          this.subjectMasterGroupings.push(i + 1)
          fieldData[`sub_grp_master_id[${i + 1}]`] = data.subject_groups[i].subject_group_master_id
          // .map(element => {
          //   return element.subject_group_master_id
          // })
        }
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldData)
      })
    },
    makeOnlineApplicationFormData(values) {
      let returnData = values
      returnData.start_date = moment(values.start_date).format('YYYY-MM-DD')
      returnData.end_date = moment(values.end_date).format('YYYY-MM-DD')
      returnData.admission_last_date = moment(values.admission_last_date).format('YYYY-MM-DD')
      returnData.subject_group = values.subject_group ? values.subject_group.filter(item => item) : ''
      // returnData.sub_grp_master_id = values.subject_group ? values.subject_group.filter(item => item) : ''
      return returnData
    },
  },
}
</script>
